export const ueberUnsFooterData = [
  {
    type: "FooterHeroColumn",
    title: "B_I MEDIEN",
    link: "/",
    youtube: "",
    paragraph:
      "Finden und vergeben Sie öffentliche und private Aufträge in ganz Deutschland.",
  },
  {
    type: "FooterSpacerMobile",
  },
  {
    type: "FooterColumn",
    title: "Aufträge finden",
    link: "/ausschreibungsdienste",
    highlighted_text: "Für Auftragnehmer:",
    column_items: [
      {
        type: "FooterLink",
        link: "/ausschreibungsdienste",
        label: "Aufträge finden",
      },
      {
        type: "FooterLink",
        link: "/vergabe-wissen/blog",
        label: "Vergaberecht (Auftragnehmer)",
      },
      {
        type: "FooterLink",
        link: "/ausschreibungsdienste/support",
        label: "Support",
      },
    ],
  },
  {
    type: "FooterColumn",
    title: "Aufträge vergeben",
    link: "/evergabe",
    highlighted_text: "Für Auftraggeber:",
    column_items: [
      {
        type: "FooterLink",
        link: "/evergabe/produkt",
        label: "Produkt",
      },
      {
        type: "FooterLink",
        link: "/evergabe/support",
        label: "Support",
      },
    ],
  },
  {
    type: "FooterSpacerMobile",
  },
  {
    type: "FooterColumn",
    title: "B_I baufachzeitschriften",
    link: "/fachzeitschriften",
    highlighted_text: "Unser Nachrichtenportal:",
    column_items: [
      {
        type: "FooterLink",
        link: "/fachzeitschriften",
        label: "Nachrichtenportal",
      },
      {
        type: "FooterLink",
        link: "/ueber-uns/media",
        label: "Mediadaten",
      },
      {
        type: "FooterLink",
        link: "/ueber-uns/redaktion",
        label: "Redaktion",
      },
    ],
  },
]
